import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  useMediaQuery,
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { X } from 'react-bootstrap-icons';
import { Button as BootstrapButton } from 'react-bootstrap';
import './style/style.scss';

const PuzPopModal = ({ open, onClose }) => {
  const theme = createTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog 
      open={open} 
      onClose={() => {}} 
      maxWidth="md" 
      fullWidth
    >
      <DialogTitle style={{ position: 'relative', paddingRight: '48px' }}>
        {/* <Box display="flex" justifyContent="center" width="100%">
          <img
            src="/puzpop_512.png"
            alt="Puz Pop App"
            style={{ width: '100px', height: '100px', marginBottom: '20px' }}
          />
        </Box> */}
        <Typography variant="h5" align="center" gutterBottom style={{ paddingTop: '15px' }}>
          Ridella now has a mobile app!
        </Typography>
        <BootstrapButton
          variant="link"
          onClick={onClose}
          className="close-button"
        >
          <X size={28} />
        </BootstrapButton>
      </DialogTitle>


      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'}>
        <DialogContent style={{ paddingLeft: isMobile ? '20px' : '50px', paddingRight: isMobile ? '20px' : '50px' }}>
          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Typography variant="body1" align="left" gutterBottom style={{ fontFamily: 'Arial', marginBottom: '0.5em' }}>
              Hey Ridella fans!
            </Typography>
            <Typography variant="body1" align="left" gutterBottom style={{ fontFamily: 'Arial', marginBottom: '0.5em' }}>
              Over the last few months, I have been hard at work on a mobile app for Ridella and a suite of other games.
              The app is called PuzPop and it is now available on the App Store and Google Play.
            </Typography>
            <Typography variant="body1" align="left" gutterBottom style={{ fontFamily: 'Arial', marginBottom: '1em' }}>
              PuzPop includes:
            </Typography>
            <ul style={{ marginTop: '-1em', paddingLeft: '20px', fontFamily: 'Arial' }}>
              <li>Ridella</li>
              <li>Clique</li>
              <li>Proximity</li>
              <li>Crossword puzzles (in Midi and Mini sizes)</li>
              <li>Sudoku</li>
            </ul>
            <Typography variant="body1" align="left" gutterBottom style={{ fontFamily: 'Arial', marginTop: '-0.5em' }}>
              Give it a download and a review - and feel free to send any feedback using <a href="https://ridella.xyz/contact" target="_blank" rel="noopener noreferrer">the contact form</a>. 
              Thanks for playing!
              <br />
              - Dylan
            </Typography>
          </Box>
        </DialogContent>
        {!isMobile && (
          <Box display="flex" alignItems="center" justifyContent="center" style={{ width: '50%', paddingRight: '50px' }}>
            <img
              src="/iphone-1-home-left.png"
              alt="PuzPop App Screenshot"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Box>
        )}
      </Box>
      <Box display="flex" justifyContent="center" mb={4}>
        <a 
          href="https://apps.apple.com/us/app/puzpop/id6670177208"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginRight: '10px' }}
        >
          <img 
            src="/Download_on_the_App_Store.svg" 
            alt="Download on the App Store" 
            style={{ height: '40px' }}
          />
        </a>
        <a 
          href="https://play.google.com/store/apps/details?id=com.puzpop.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img 
            src="/GetItOnGooglePlay.png" 
            alt="Get it on Google Play" 
            style={{ height: '40px' }}
          />
        </a>
      </Box>
      {isMobile && (
        <Box display="flex" justifyContent="center" mb={2}>
          <img
            src="/iphone-1-home-left.png"
            alt="PuzPop App Screenshot"
            style={{ maxWidth: '80%', height: 'auto' }}
          />
        </Box>
      )}
    </Dialog>
  );
};

export default PuzPopModal;